import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchData, viewdata, viewattachmentdata, viewdataattach } from '../reduxactions/donorrsactions/DNeedViewReducAction';
import { RootState } from '../reducers';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { Divider } from 'primereact/divider';
import { Avatar } from 'primereact/avatar';
import { GFNButton } from '../ui';
const DonorNeedsView = () => {
    var imageName = require('./../assets/img/g12.png')
    var imageName1 = require('./../assets/img/money.jpg')

    const location = useLocation();
    const [queryParams, setQueryParams] = useState(null);
    const [showButton, setShowButton] = useState(false);
    const userid = window.sessionStorage.getItem("userid");
    // const needid = window.sessionStorage.getItem("needid");

    //const [needid, setNeedid] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("Id") as any);
    }, [location]);
    const { Id } = useParams();
    const { needid } = useParams();


    const [globalFilter, setGlobalFilter] = useState('');


    const uid = window.sessionStorage.getItem('uid');
    const dispatch = useDispatch()
    const data = useSelector((state: RootState) => state.dneedview.data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData(Id, needid) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    const fetchDataViewAsync = async () => {
        try {
            await dispatch(viewdata(Id) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    const fetchDataattachViewAsync = async () => {
        try {
            await dispatch(viewattachmentdata(Id) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    useEffect(() => {
        fetchDataAsync();
        fetchDataattachViewAsync();
        fetchDataViewAsync();

    }, [dispatch])

    console.log("datas", data)
    const dataview = useSelector((state: RootState) => state.dneedview.dataview);
    const attachdataview = useSelector((state: RootState) => state.dneedview.attachdataview);
    const attachdata = useSelector((state: RootState) => state.dneedview.attachdata);


    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }
    //To assign data 
    const [assignData, setassignData] = useState({
        Id: '',
    });
    const [userAddress, setUserAddress] = useState()
    const viewupload = (item: any) => {
        // setassignData({
        //     Id: item.Id,

        // });
        let docid = item.address
        setUserAddress(docid)
        setfield(true);
        // fetchDataAsyncdialog();
    };
    const fetchDataAsyncdialog = async () => {
        try {
            const { Id } = assignData;
            console.log("ids", Id)
            dispatch(viewdataattach(uid, Id) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }

    const navigate = useNavigate();

    //To open view
    const Donates = (response: any) => {
        const url = `/donation/${userid}/${response.orgID}/${Id}`;

        console.log('Row ID:', response.Id, response.orgID);
        navigate(url);
    };
    let buttonShown = false;
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewdonor-needs.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2 align-items-center justify-content-between">
                                    <div className="col">
                                        <h1>User Profile</h1>
                                    </div>

                                    <div className="col-fixed">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{ color: "blue", fontSize: 15, cursor: "pointer" }}
                                        >
                                            Help for this Page &nbsp;
                                            <i
                                                className="pi pi-question-circle"
                                                style={{
                                                    backgroundColor: "orange",
                                                    color: "white",
                                                    padding: "4px",
                                                    borderRadius: "50%"
                                                }}
                                            ></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">View Needs</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <section className="content">
                            {data.map((response: any, index: number) => {
                                const showDonateButton =
                                    response.budget_amount !== response.received_amount;

                                return (
                                    <Panel>
                                        {/* Donate Button */}
                                        {showDonateButton && (
                                            <div className="flex justify-content-end mb-3">
                                                <GFNButton
                                                    label="Donate"
                                                    data-testid="donate-btn"
                                                    buttonType="secondary"
                                                    onClick={() => {
                                                        Donates(response);
                                                        setShowButton(true);
                                                    }}
                                                />
                                            </div>
                                        )}
                                        <div className="grid mt-3" key={index}>

                                            {/* LEFT SIDE - COL 3 */}
                                            <div className="col-12 lg:col-3">
                                                {/* Profile Card */}
                                                <Card
                                                    className="surface-card border-1 border-300 border-round-xl shadow-2 p-3 mb-3"
                                                >
                                                    <div className="flex flex-column align-items-center text-center">

                                                        <img
                                                            src={response.profilepic}
                                                            alt="User"
                                                            className="border-circle mb-3"
                                                            style={{
                                                                width: '100px',
                                                                height: '100px',
                                                                objectFit: 'cover',
                                                                border: '3px solid #dee2e6'
                                                            }}
                                                        />

                                                        <span className="text-700 font-semibold text-sm">
                                                            Organization Head
                                                        </span>

                                                        <span
                                                            className="text-900 font-bold text-lg"
                                                            data-testid="value-show"
                                                        >
                                                            {response.nameofthehead}
                                                        </span>
                                                    </div>

                                                    <Divider className="my-3" />

                                                    <div className="flex flex-column gap-3 text-sm">

                                                        <div className="flex justify-content-between align-items-center">
                                                            <span className="text-600 font-medium">
                                                                License No
                                                            </span>

                                                            <span className="text-900 font-semibold">
                                                                {response.licenseno}
                                                            </span>
                                                        </div>

                                                        <div className="flex justify-content-between align-items-center">
                                                            <span className="text-600 font-medium">
                                                                Expiry Date
                                                            </span>

                                                            <span className="text-900 font-semibold">
                                                                {response.license_expdate}
                                                            </span>
                                                        </div>

                                                        <div className="flex justify-content-between align-items-center">
                                                            <span className="text-600 font-medium">
                                                                Contact No
                                                            </span>

                                                            <span className="text-900 font-semibold">
                                                                {response.mobile}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </Card>

                                                {/* About Organization */}
                                                <Card
                                                    className="surface-card border-1 border-300 border-round-xl shadow-2 p-3"
                                                >
                                                    <Panel
                                                        header="About Organization"
                                                        className="border-none p-0"
                                                    >
                                                        <div className="flex flex-column gap-3 text-sm">

                                                            <div className="flex justify-content-between align-items-center">
                                                                <span className="text-600 font-medium">
                                                                    Name
                                                                </span>

                                                                <span className="text-900 font-semibold text-right">
                                                                    {response.nameoftheorg}
                                                                </span>
                                                            </div>

                                                            <Divider />

                                                            <div className="flex justify-content-between align-items-center">
                                                                <span className="text-600 font-medium">
                                                                    Location
                                                                </span>

                                                                <span className="text-900 font-semibold text-right">
                                                                    {response.address}
                                                                </span>
                                                            </div>

                                                            <Divider />

                                                            <div className="flex justify-content-between align-items-center">
                                                                <span className="text-600 font-medium">
                                                                    Designation
                                                                </span>

                                                                <span className="text-900 font-semibold text-right">
                                                                    {response.designation}
                                                                </span>
                                                            </div>

                                                            <Divider />

                                                            <div className="flex justify-content-between align-items-center">
                                                                <span className="text-600 font-medium">
                                                                    Email
                                                                </span>

                                                                <span className="text-900 font-semibold text-right">
                                                                    {response.email}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </Panel>
                                                </Card>

                                            </div>

                                            {/* RIGHT SIDE - COL 9 */}
                                            <div className="col-12 lg:col-9">

                                                {/* Need Type */}
                                                <Panel header="Need Type">
                                                    <div
                                                        className="flex align-items-center gap-2 mb-3"
                                                    >
                                                        <img
                                                            src={imageName}
                                                            alt="logo"
                                                            width={50}
                                                            height={50}
                                                            className="border-circle"
                                                            style={{
                                                                border: '2px solid #dee2e6'
                                                            }}
                                                        />

                                                        <span className="username">
                                                            Need Type
                                                        </span>
                                                    </div>

                                                    <InputText
                                                        disabled
                                                        className="w-full"
                                                        value={response.needtype}
                                                        style={{
                                                            backgroundColor: 'lightgrey',
                                                            color: 'black'
                                                        }}
                                                    />
                                                </Panel>

                                                {/* Need Title */}
                                                <Card className="mt-3">
                                                    <div className="flex align-items-center gap-2 mb-3">
                                                        <img
                                                            src={imageName}
                                                            alt="logo"
                                                            width={50}
                                                            height={50}
                                                            className="border-circle"
                                                            style={{
                                                                border: '2px solid #dee2e6'
                                                            }}
                                                        />

                                                        <span className="username">
                                                            Need Title
                                                        </span>
                                                    </div>

                                                    <h3>{response.needtittle}</h3>
                                                </Card>

                                                {/* Budget Details */}
                                                <Card className="mt-3">
                                                    <div className="grid">

                                                        <div className="col-12 md:col-6">
                                                            <div className="flex align-items-center gap-3">

                                                                <img
                                                                    src={imageName1}
                                                                    alt="logo"
                                                                    width={70}
                                                                    height={70}
                                                                    className="border-circle"
                                                                    style={{
                                                                        border: '2px solid #dee2e6'
                                                                    }}
                                                                />

                                                                <div>
                                                                    <span className="username block">
                                                                        Planned Budget Amount
                                                                    </span>

                                                                    <h3>{response.budget_amount}</h3>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 md:col-6">
                                                            <div className="flex align-items-center gap-3">

                                                                <img
                                                                    src={imageName1}
                                                                    alt="logo"
                                                                    width={70}
                                                                    height={70}
                                                                    className="border-circle"
                                                                    style={{
                                                                        border: '2px solid #dee2e6'
                                                                    }}
                                                                />

                                                                <div>
                                                                    <span className="username block">
                                                                        Received Amount
                                                                    </span>

                                                                    <h3>{response.received_amount}</h3>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </Card>

                                                {/* Donations */}
                                                <Panel
                                                    header="Donations"
                                                    className="mt-3"
                                                    toggleable
                                                >
                                                    <div className="flex justify-content-end mb-3">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search ml-2" />

                                                            <InputText
                                                                value={globalFilter}
                                                                onChange={(e) =>
                                                                    setGlobalFilter(e.target.value)
                                                                }
                                                                placeholder="Global Search"
                                                                style={{ paddingLeft: '2rem' }}
                                                            />
                                                        </span>
                                                    </div>

                                                    <DataTable
                                                        value={dataview}
                                                        stripedRows
                                                        paginator
                                                        rows={5}
                                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                                        tableStyle={{ minWidth: '50rem' }}
                                                        globalFilter={globalFilter}
                                                    >
                                                        <Column
                                                            body={(rowData, { rowIndex }) =>
                                                                rowIndex + 1
                                                            }
                                                            header="S.No"
                                                        />

                                                        <Column
                                                            field="donor_name"
                                                            sortable
                                                            header="Donor Name"
                                                        />

                                                        <Column
                                                            field="cdate"
                                                            sortable
                                                            header="DATE"
                                                        />

                                                        <Column
                                                            field="budget_amount"
                                                            sortable
                                                            header="AMOUNT"
                                                        />
                                                    </DataTable>
                                                </Panel>

                                                {/* Description */}
                                                <Panel
                                                    header="Description"
                                                    className="mt-3"
                                                    toggleable
                                                >
                                                    <div
                                                        className="flex align-items-center gap-2 mb-3"
                                                    >
                                                        <img
                                                            src={imageName}
                                                            alt="logo"
                                                            width={50}
                                                            height={50}
                                                            className="border-circle"
                                                            style={{
                                                                border: '2px solid #dee2e6'
                                                            }}
                                                        />

                                                        <span className="username">
                                                            Need Description
                                                        </span>
                                                    </div>

                                                    <InputTextarea
                                                        autoResize
                                                        value={response.description}
                                                        disabled
                                                        rows={5}
                                                        className="w-full"
                                                    />
                                                </Panel>

                                                {/* Attachments */}
                                                <Panel
                                                    className="mt-3"
                                                    toggleable
                                                >
                                                    <div className="flex flex-column align-items-start mb-4">

                                                        <img
                                                            src={imageName}
                                                            alt="logo"
                                                            width={50}
                                                            height={50}
                                                            className="border-circle mb-2"
                                                            style={{
                                                                border: '2px solid #dee2e6'
                                                            }}
                                                        />

                                                        <span className="username">
                                                            Related Attachments
                                                        </span>

                                                        <span className="description">
                                                            Organization Posted this attachments related to this need
                                                        </span>
                                                    </div>

                                                    <div className="grid">
                                                        {attachdataview.map((item: any, attachIndex: number) => (
                                                            <div
                                                                className="col-12 md:col-6 lg:col-4"
                                                                key={attachIndex}
                                                            >
                                                                <Card className="p-2">

                                                                    {item.type === 'local' ? (
                                                                        <img
                                                                            src={item.path}
                                                                            alt="logo"
                                                                            width="100%"
                                                                            height={250}
                                                                            className="mb-3"
                                                                            style={{
                                                                                objectFit: 'cover'
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <video
                                                                            width="100%"
                                                                            height={250}
                                                                            controls
                                                                            className="mb-3"
                                                                        >
                                                                            <source
                                                                                src={item.path}
                                                                                type="video/mp4"
                                                                            />
                                                                        </video>
                                                                    )}

                                                                    <h5>{item.vdate}</h5>

                                                                    <Button
                                                                        className="mr-1"
                                                                        severity="info"
                                                                        icon="pi pi-map-marker"
                                                                        rounded
                                                                        outlined
                                                                        onClick={() => viewupload(item)}
                                                                    />

                                                                </Card>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Panel>

                                            </div>
                                        </div>
                                    </Panel>
                                );
                            })}
                        </section>
                        <Dialog header="View" style={{ width: '35vw' }} visible={acceptfield} onHide={cancelfield}>
                            <>
                                <span style={{ alignSelf: 'center' }}><h3>{userAddress}</h3></span>
                                <Divider></Divider>

                            </>
                            <Button label="Close" onClick={cancelfield} className="mr-3 p-button-secondary" />
                        </Dialog>
                    </div >
                </div>
            </div>
        </div>

    )
}

export default DonorNeedsView
